import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { Utilities } from '../../ui/pages/Utilities';
import { UtilityGist } from '../../ui/pages/UtilityGist';

export function createUtilitiesRoutes<TRootRoute extends AnyRoute>(rootRoute: TRootRoute) {
  const utilitiesRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/utilities',
    component: Utilities,
  });

  const utilityGistRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/utilities/gists/$id',
    component: UtilityGist,
  });

  return {
    utilitiesRoute,
    utilityGistRoute,
  };
}
